import "core-js/modules/es.function.name.js";
import "core-js/modules/es.string.starts-with.js";
export default (function () {
  var route = useRoute();
  var isHome = computed(function () {
    var _route$name;
    return (_route$name = route.name) === null || _route$name === void 0 ? void 0 : _route$name.startsWith('index___');
  });
  return {
    isHome: isHome
  };
});